import api from './client';

// API Keys
export const apiKeysAPI = {
  getAll: () => api.get('/api-keys'),
  create: (data) => api.post('/api-keys', data),
  update: (id, data) => api.put(`/api-keys/${id}`, data),
  delete: (id) => api.delete(`/api-keys/${id}`),
  getPermissions: () => api.get('/api-keys/permissions'),
};
